import { render } from "./UserRegister.vue?vue&type=template&id=5d3ca580"
import script from "./UserRegister.vue?vue&type=script&lang=js"
export * from "./UserRegister.vue?vue&type=script&lang=js"
script.render = render

export default script